import { ConnectedCartIcon as CartIcon } from 'tenants/cccsyd/cart_icon';
import Logout from 'tenants/cccsyd/auth/logout';

export default {
  CartIcon,
  Logout,
};
